import React from "react";
import {getDateFormat} from "../../../../../utils/functions";

const JInformation = (parent) => {
	const record = parent.record;

	let wos = 0;
	let scopus = 0;
	let kci = 0;
	let nature = 0;
	if (record.db_register) {
		record.db_register.map((item, num) => {
			if (item.register_db_gubun === 'wos')
				wos++;
			if (item.register_db_gubun === 'scopus')
				scopus++;
			if (item.register_db_gubun === 'kci')
				kci++;
			if (item.register_db_gubun === 'nature')
				nature++;
		})
	}

	return (
		<div className="mt-65 journal-detail-information">
			<div className="d-flex justify-content-between align-items-center mb-px-26">
				<div className="d-flex align-items-center">
					<h3 className="con-title">저널 등재 정보</h3>
				</div>
			</div>
			<div>
				<div className="row row-cols-4 ml-px-n12 mr-px-n12">
					<div className="col pl-px-12 pr-px-12">
						<div className="square-card-item p-3">
							<div className="btn btn-lightpurple mt-2 mb-4">Web of Science</div>
							{record.db_register && record.db_register.map((item, num) => {
								// if (item.register_db_gubun === 'scopus' || item.register_db_type.includes('KCI'))
								// 	return;
								if (item.register_db_gubun !== 'wos')
									return;
								return (
									<div key={num}>
										<div className="d-flex no-gutters justify-content-between">
											<div className="col-3 text-left"><strong>{item.register_db_name}</strong></div>
											<div className="col-9 text-right">
												<div className="">{item.register_status === 'in' ? '등재' : '탈락'} - {getDateFormat(item.register_yyyymm)}</div>
											</div>
										</div>
									</div>
								)
							})}
							{wos <= 0 && <div>
								<div className="no-gutters justify-content-between">
									<div className="text-center">등재 이력이 없습니다.</div>
								</div>
							</div>}
						</div>
					</div>
					<div className="col pl-px-12 pr-px-12">
						<div className="square-card-item p-2">
							<div className="btn btn-lightorange mt-3 mb-4">Scopus</div>
							{record.db_register && record.db_register.map((item, num) => {
								if (item.register_db_gubun !== 'scopus')
									return;
								return (
									<div key={num}>
										<div className="no-gutters justify-content-between">
											<div className="col-12 text-center">
												<div className="">{item.register_status === 'in' ? '등재' : '탈락'} - {getDateFormat(item.register_yyyymm)}</div>
											</div>
										</div>
									</div>
								)
							})}
							{scopus <= 0 && <div>
								<div className="no-gutters justify-content-between">
									<div className="text-center">등재 이력이 없습니다.</div>
								</div>
							</div>}
						</div>
					</div>
					<div className="col pl-px-12 pr-px-12">
						<div className="square-card-item p-2">
							<div className="btn btn-skyblue mt-3 mb-4">Nature Index</div>
							{record.db_register && record.db_register.map((item, num) => {
								// if (item.register_db_gubun === 'scopus' || item.register_db_type.includes('KCI'))
								// 	return;
								if (item.register_db_gubun !== 'nature')
									return;
								return (
									<div key={num}>
										<div className="no-gutters justify-content-between">
											<div className="col-12 text-center">
												<div className="">{item.register_status === 'in' ? '등재' : '탈락'} - {getDateFormat(item.register_yyyymm)}</div>
											</div>
										</div>
									</div>
								)
							})}
							{nature <= 0 && <div>
								<div className="no-gutters justify-content-between">
									<div className="text-center">등재 이력이 없습니다.</div>
								</div>
							</div>}
						</div>
					</div>
					<div className="col pl-px-12 pr-px-12">
						<div className="square-card-item p-2">
							<div className="btn btn-lightgreen mt-3 mb-4">KCI</div>
							{record.db_register && record.db_register.map((item, num) => {
								if (item.register_db_gubun !== 'kci')
									return;
								return (
									<div key={num}>
										<div className="d-flex no-gutters justify-content-between">
											<div className="col-5 text-left"><strong>{item.register_db_name}</strong></div>
											<div className="col-7 text-right">
												<div className="">{item.register_status === 'in' ? '등재' : '탈락'} - {getDateFormat(item.register_yyyymm)}</div>
											</div>
										</div>
									</div>
								)
							})}
							{kci <= 0 && <div>
								<div className="no-gutters justify-content-between">
									<div className="text-center">등재 이력이 없습니다.</div>
								</div>
							</div>}
						</div>
					</div>
				</div>
				<div className="example-code mt-2" style={{border : '1px solid #e5e5e5'}}>
					<div className="dot-text-list">
						<div className="list-cell">SCI급 저널 : Web of Science 핵심컬렉션 DB 중 SCIE, SSCI, AHCI 저널을 통칭함(ESCI 저널 제외)</div>
						<div className="list-cell">ESCI는 SCI급 저널의 후보군으로 판단되며, ESCI의 등재일은 정확하지 않으며 업데이트 중</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default JInformation;
